import { UploadIcon } from "./icons";
import "../../../styles/panel/user/StoreStep.css";
import { useEffect, useState } from "react";
import {
  checkSlug,
  fetchCities,
  fetchProvinces,
  fetchStoreTypes,
} from "../../../api/storeRequest";
const MOBILE_REGEX = /^09\d{9}$/;
const LANDLINE_REGEX = /^0\d{10}$/;
const SLUG_REGEX = /^[a-zA-Z0-9_]+$/;

function getFieldError(name, store) {
  switch (name) {
    case "storeName":
      return store.storeName.trim() ? "" : "نام فروشگاه الزامی است";
    case "slug": {
      const slug = store.slug.trim();
      if (!slug) return "آدرس فروشگاه الزامی است";
      return SLUG_REGEX.test(slug)
        ? ""
        : "آدرس فروشگاه فقط می‌تواند شامل حروف انگلیسی، عدد و _ باشد";
    }
    case "province":
      return store.province ? "" : "انتخاب استان الزامی است";
    case "city":
      return store.city ? "" : "انتخاب شهر الزامی است";
    case "category":
      return store.category ? "" : "انتخاب دسته فروشگاه الزامی است";
    case "mobile":
      if (!store.mobile.trim()) return "شماره موبایل الزامی است";
      return MOBILE_REGEX.test(store.mobile.trim())
        ? ""
        : "شماره موبایل معتبر نیست";
    case "landline":
      if (!store.landline.trim()) return "";
      return LANDLINE_REGEX.test(store.landline.trim())
        ? ""
        : "شماره ثابت معتبر نیست";
    case "address":
      return store.address.trim() ? "" : "آدرس کامل الزامی است";
    default:
      return "";
  }
}

export default function StoreStep({ store, setStore }) {
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [storeTypes, setStoreTypes] = useState([]);
  const [slugStatus, setSlugStatus] = useState(null); // null | "checking" | "available" | "taken"
  const [touched, setTouched] = useState({});

  const markTouched = (name) =>
    setTouched((t) => (t[name] ? t : { ...t, [name]: true }));

  const errorOf = (name) => (touched[name] ? getFieldError(name, store) : "");

  useEffect(() => {
    const load = async () => {
      const p = await fetchProvinces();
      setProvinces(p?.data || []);

      const st = await fetchStoreTypes();
      setStoreTypes(st?.data || []);
    };
    load();
  }, []);

  useEffect(() => {
    const loadCities = async () => {
      if (!store.province) {
        setCities([]);
        return;
      }
      const response = await fetchCities(store.province);
      setCities(response?.data || []);
    };

    loadCities();
  }, [store.province]);

  const checkingSlug = async (slug) => {
    if (!slug.trim()) {
      setSlugStatus(null);
      return;
    }

    setSlugStatus("checking");

    try {
      const res = await checkSlug(slug.trim());
      setSlugStatus(res.data.exists ? "taken" : "available");
    } catch {
      setSlugStatus(null);
    }
  };
  return (
    <>
      <h3 className="request-step-title">اطلاعات پایه فروشگاه</h3>
      <p className="request-step-sub">
        این اطلاعات روی صفحه اصلی سایت شما نمایش داده می‌شود
      </p>
      <div className="request-grid">
        <div className="request-field">
          <label>نام فروشگاه</label>
          <input
            type="text"
            className={errorOf("storeName") ? "input-error" : ""}
            value={store.storeName}
            onChange={(e) => setStore({ ...store, storeName: e.target.value })}
            onBlur={() => markTouched("storeName")}
            placeholder="مثال: فروشگاه دنیای دیجیتال"
          />
          {errorOf("storeName") && (
            <span className="field-error">{errorOf("storeName")}</span>
          )}
        </div>
        <div className="request-field">
          <label>
            آدرس فروشگاه (www.dokana.ir/
            {store.slug.trim() ? store.slug.trim() : "alistore"})
          </label>

          <div className="slug-input-wrap">
            <input
              type="text"
              dir="rtl"
              className={
                slugStatus === "taken" || errorOf("slug")
                  ? "slug-input-error"
                  : slugStatus === "available"
                    ? "slug-input-success"
                    : ""
              }
              value={store.slug}
              onChange={(e) => {
                setStore({
                  ...store,
                  slug: e.target.value.replace(/[^a-zA-Z0-9_]/g, ""),
                });
                setSlugStatus(null);
              }}
              onBlur={() => {
                markTouched("slug");
                checkingSlug(store.slug);
              }}
              placeholder="مثال: alistore"
            />

            {slugStatus === "checking" && (
              <span
                className="slug-status-icon slug-status-loading"
                aria-label="در حال بررسی"
              >
                <svg viewBox="0 0 24 24" fill="none">
                  <circle
                    cx="12"
                    cy="12"
                    r="9"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeDasharray="42 100"
                  />
                </svg>
              </span>
            )}

            {slugStatus === "taken" && (
              <span
                className="slug-status-icon slug-status-error"
                aria-label="این آدرس قبلاً استفاده شده است"
              >
                <svg viewBox="0 0 24 24" fill="none">
                  <path
                    d="M6 6L18 18M18 6L6 18"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
            )}

            {slugStatus === "available" && (
              <span
                className="slug-status-icon slug-status-success"
                aria-label="این آدرس قابل استفاده است"
              >
                <svg viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 13l4 4L19 7"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            )}
          </div>
          {errorOf("slug") ? (
            <span className="field-error">{errorOf("slug")}</span>
          ) : (
            slugStatus === "taken" && (
              <span className="field-error">
                این آدرس قبلاً استفاده شده است
              </span>
            )
          )}
        </div>
        <div className="request-field">
          <label className="field-label-tip">
            تصویر فروشگاه <span className="optional">(اختیاری)</span>
            <span className="field-tooltip">
              این تصویر در سایت اصلی نمایش داده می‌شود. لطفاً تصویری جذاب برای
              معرفی فروشگاه انتخاب کنید.
            </span>
          </label>
          <label className="file-input">
            <UploadIcon />
            <span
              className="file-input-name"
              title={store.imageFile ? store.imageFile.name : undefined}
            >
              {store.imageFile ? store.imageFile.name : "انتخاب تصویر"}
            </span>
            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setStore({
                  ...store,
                  imageFile: e.target.files?.[0] || null,
                })
              }
            />
          </label>
        </div>
        <div className="request-field">
          <label>
            لوگو فروشگاه <span className="optional">(اختیاری)</span>
          </label>
          <label className="file-input">
            <UploadIcon />
            <span
              className="file-input-name"
              title={store.logoFile ? store.logoFile.name : undefined}
            >
              {store.logoFile ? store.logoFile.name : "انتخاب لوگو"}
            </span>
            <input
              type="file"
              accept="image/*"
              onChange={(e) =>
                setStore({
                  ...store,
                  logoFile: e.target.files?.[0] || null,
                })
              }
            />
          </label>
        </div>

        <div className="request-field">
          <label>استان</label>
          <select
            className={errorOf("province") ? "input-error" : ""}
            value={store.province}
            onChange={(e) => {
              const selected = provinces.find(
                (p) => String(p.province_id) === e.target.value,
              );
              setStore({
                ...store,
                province: e.target.value,
                provinceName: selected ? selected.name : "",
                city: "",
                cityName: "",
              });
            }}
            onBlur={() => markTouched("province")}
          >
            <option value="">انتخاب استان</option>
            {provinces.map((p) => (
              <option key={p.province_id} value={p.province_id}>
                {p.name}
              </option>
            ))}
          </select>
          {errorOf("province") && (
            <span className="field-error">{errorOf("province")}</span>
          )}
        </div>
        <div className="request-field">
          <label>شهر</label>
          <select
            className={errorOf("city") ? "input-error" : ""}
            value={store.city}
            disabled={!store.province}
            onChange={(e) => {
              const selected = cities.find(
                (c) => String(c.city_id) === e.target.value,
              );
              setStore({
                ...store,
                city: e.target.value,
                cityName: selected ? selected.name : "",
              });
            }}
            onBlur={() => markTouched("city")}
          >
            <option value="">انتخاب شهر</option>
            {(cities || []).map((c) => (
              <option key={c.city_id} value={c.city_id}>
                {c.name}
              </option>
            ))}
          </select>
          {errorOf("city") && (
            <span className="field-error">{errorOf("city")}</span>
          )}
        </div>
        <div className="request-field">
          <label>دسته فروشگاه</label>
          <select
            className={errorOf("category") ? "input-error" : ""}
            value={store.category}
            onChange={(e) => {
              const selected = storeTypes.find(
                (type) => String(type.type_id) === e.target.value,
              );
              setStore({
                ...store,
                category: e.target.value,
                categoryName: selected ? selected.title : "",
              });
            }}
            onBlur={() => markTouched("category")}
          >
            <option value="">انتخاب دسته</option>
            {(storeTypes || []).map((type) => (
              <option key={type.type_id} value={type.type_id}>
                {type.title}
              </option>
            ))}
          </select>
          {errorOf("category") && (
            <span className="field-error">{errorOf("category")}</span>
          )}
        </div>

        <div className="request-field">
          <label>
            شماره ثابت <span className="optional">(اختیاری)</span>
          </label>
          <input
            type="text"
            dir="ltr"
            inputMode="numeric"
            maxLength={11}
            className={errorOf("landline") ? "input-error" : ""}
            value={store.landline}
            onChange={(e) =>
              setStore({
                ...store,
                landline: e.target.value.replace(/[^0-9]/g, ""),
              })
            }
            onBlur={() => markTouched("landline")}
            placeholder="021xxxxxxxx"
          />
          {errorOf("landline") && (
            <span className="field-error">{errorOf("landline")}</span>
          )}
        </div>

        <div className="request-field">
          <label>شماره موبایل</label>
          <input
            type="text"
            dir="ltr"
            inputMode="numeric"
            maxLength={11}
            className={errorOf("mobile") ? "input-error" : ""}
            value={store.mobile}
            onChange={(e) =>
              setStore({
                ...store,
                mobile: e.target.value.replace(/[^0-9]/g, ""),
              })
            }
            onBlur={() => markTouched("mobile")}
            placeholder="09xxxxxxxxx"
          />
          {errorOf("mobile") && (
            <span className="field-error">{errorOf("mobile")}</span>
          )}
        </div>

        <div className="request-field full">
          <label>آدرس کامل</label>
          <textarea
            className={errorOf("address") ? "input-error" : ""}
            value={store.address}
            onChange={(e) => setStore({ ...store, address: e.target.value })}
            onBlur={() => markTouched("address")}
            placeholder="استان، شهر، خیابان، پلاک..."
          />
          {errorOf("address") && (
            <span className="field-error">{errorOf("address")}</span>
          )}
        </div>
      </div>
    </>
  );
}

export function isStoreStepValid(store) {
  const mobileValid = /^09\d{9}$/.test(store.mobile.trim());
  const landlineValid =
    !store.landline.trim() || /^0\d{10}$/.test(store.landline.trim());
  const slugValid = /^[a-zA-Z0-9_]+$/.test(store.slug.trim());

  return !!(
    store.storeName.trim() &&
    slugValid &&
    store.province &&
    store.city &&
    store.category &&
    mobileValid &&
    landlineValid &&
    store.address.trim()
  );
}
